var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDashboard = function SvgDashboard(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 14.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 8.5l-2.586 2.586"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21 12.5a8.962 8.962 0 0 1-3.762 7.3c-.666.465-1.46.71-2.272.7h-5.94a3.838 3.838 0 0 1-2.226-.672A8.988 8.988 0 0 1 12.282 3.5a9.1 9.1 0 0 1 8.718 9Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDashboard);
export default ForwardRef;